<template>
    <section class="userSteps">
       <Header />
        <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div>
        <div class="publicProfile row">
            <div class="col-12">
                <router-link class="d-flex align-items-center backBtn medium" to="/personal-details">
                    <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> {{$t('mannual_proof.text1')}}
                </router-link>
                <div class="counterStep text-end">
                    <p>{{$t('mannual_proof.text2')}}</p>
                </div>
            </div>
            <div class="col-12">
                <div class="mainTitle mb-5">
                    <h3 class="mb-3 clash">{{$t('trading_account.text1')}}<span class="bgTitle dark">{{$t('trading_account.text2')}}</span></h3>
                    <p>{{$t('trading_account.text3')}}<br />
                        {{$t('trading_account.text4')}}</p>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="card-body">
                    <h2 class="d-flex align-items-center clashmedium">{{$t('trading_account.text5')}}<i class="small fa fa-info-circle"
                            aria-hidden="true"></i></h2>
                    <p>{{$t('trading_account.text6')}}</p>
                    <div class="d-flex align-items-center">
                        <router-link to="/add-trading-account" class="grd_btn semibold d-flex align-items-center h-38 me-3">
                            <vue-feather class="me-1" type="plus" size="18"></vue-feather>{{$t('trading_account.text7')}}
                        </router-link>
                        <div class="connected d-flex align-items-center">
                            <p class="mb-0 me-2">{{$t('trading_account.text8')}}</p>
                            <span class="dark">{{$t('trading_account.text9')}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="card-body">
                    <h2 class="d-flex align-items-center clashmedium">{{$t('trading_account.text10')}}<i class="small fa fa-info-circle"
                            aria-hidden="true"></i></h2>
                    <p>{{$t('trading_account.text11')}}<br />{{$t('trading_account.text12')}}</p>
                    <div class="d-flex align-items-center">
                        <router-link to="/add-trading-account" class="grd_btn semibold d-flex align-items-center h-38 me-3">
                            <vue-feather class="me-1" type="plus" size="18"></vue-feather>{{$t('trading_account.text7')}}
                        </router-link>
                        <div class="connected d-flex align-items-center">
                            <p class="mb-0 me-2">{{$t('trading_account.text8')}}</p>
                            <span class="dark">{{$t('trading_account.text9')}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { useMainStore } from "@/store";
export default {
    setup() {
        const store = useMainStore();
        return { store };
      },
    data() {
        return {
            
        }
    },
    computed: {
        isActive() {
            return false
        }
    },
}
</script>